// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CommentFormController from "./comment_form_controller"
application.register("comment-form", CommentFormController)

import CustomerHistoryController from "./customer_history_controller"
import DeliveryHoursController from "./delivery_hours_controller"
application.register("customer-history", CustomerHistoryController)
application.register("delivery-hours", DeliveryHoursController)

import DecimalMaskController from "./decimal_mask_controller"
application.register("decimal-mask", DecimalMaskController)

import AllocationPolicyVehiclesController from "./allocation_policy_vehicles_controller"
application.register("allocation-policy-vehicles", AllocationPolicyVehiclesController)

import AssignmentPreviewController from "./assignment_preview_controller"
application.register("assignment-preview", AssignmentPreviewController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LocationController from "./location_controller"
application.register("location", LocationController)
application.register("orders", LocationController)
application.register("warehouses", LocationController)

import OrderMetricsController from "./order_metrics_controller"
application.register("order-metrics", OrderMetricsController)

import OrderImportStatusController from "./order_import_status_controller"
application.register("order-import-status", OrderImportStatusController)

import RoutesController from "./routes_controller"
application.register("routes", RoutesController)

import TaxIdController from "./tax_id_controller"
application.register("tax-id", TaxIdController)

import TollClassificationController from "./toll_classification_controller"
application.register("toll-classification", TollClassificationController)

import ZipLookupController from "./zip_lookup_controller"
application.register("zip-lookup", ZipLookupController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import AdminPasswordResetController from "./admin_password_reset_controller"
application.register("admin-password-reset", AdminPasswordResetController)

import AdminRouteMapController from "./admin_route_map_controller"
application.register("admin-route-map", AdminRouteMapController)

import CommunicationRulesController from "./communication_rules_form_controller"
application.register("communication-rules-form", CommunicationRulesController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import PlanLimitModal from "./plan_limit_modal_controller"
application.register("plan-limit-modal", PlanLimitModal)

import ProfileAvatarController from "./profile_avatar_controller"
application.register("profile-avatar", ProfileAvatarController)

import ListingColumnsController from "./listing_columns_controller"
application.register("listing-columns", ListingColumnsController)

import RestrictionMapController from "./restriction_map_controller"
application.register("restriction-map", RestrictionMapController)

import AreaMapController from "./area_map_controller"
application.register("area-map", AreaMapController)

import ServiceAreaVehiclesController from "./service_area_vehicles_controller"
application.register("service-area-vehicles", ServiceAreaVehiclesController)

import EvidenceCorrectionController from "./evidence_correction_controller"
application.register("evidence-correction", EvidenceCorrectionController)
